/* unplugin-vue-components disabled */import { render } from "./xLayoutSide.vue?vue&type=template&id=4b0864ea"
import script from "./xLayoutSide.vue?vue&type=script&lang=jsx"
export * from "./xLayoutSide.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__